var React = require('react');

function SmallList (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.001 1a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-18zm18 2h-18v2h18V3zM3.001 9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-18zm18 2h-18v2h18v-2zM1.001 19a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-18a2 2 0 0 1-2-2v-2zm2 0h18v2h-18v-2z","fill":"#fff"}));
}

SmallList.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = SmallList;

SmallList.default = SmallList;
